import { GET_DEVICE_TYPE, GET_DEVICE_ONBOARDING_LOGS, GET_PROCESS_NAMES } from "./actionTypes";

export const getDeviceTypeInit = () => ({
    type: GET_DEVICE_TYPE.INIT,
});

export const getDeviceTypeSuccess = (deviceTypeList) => ({
    type: GET_DEVICE_TYPE.SUCCESS,
    payload: deviceTypeList,
});

export const getDeviceTypeFailure = (errroMessage) => ({
    type: GET_DEVICE_TYPE.ERROR,
    payload: errroMessage,
});

export const getDeviceOnboardingLogsInit = () => ({
    type: GET_DEVICE_ONBOARDING_LOGS.INIT,
});

export const getDeviceOnboardingLogsSuccess = (onboardingLogs) => ({
    type: GET_DEVICE_ONBOARDING_LOGS.SUCCESS,
    payload: onboardingLogs,
});

export const getDeviceOnboardingLogsFailure = (errroMessage) => ({
    type: GET_DEVICE_ONBOARDING_LOGS.ERROR,
    payload: errroMessage,
});

export const getProcessNamesInit = () => ({
    type: GET_PROCESS_NAMES.INIT,
});

export const getProcessNamesSuccess = (processNames) => ({
    type: GET_PROCESS_NAMES.SUCCESS,
    payload: processNames,
});

export const getProcessNamesFailure = (errorMessage) => ({
    type: GET_PROCESS_NAMES.ERROR,
    payload: errorMessage,
});
